import React, { useState, useEffect, useCallback } from "react";
import { Tabs, Box } from "@my-scoot/component-library-legacy";

import useStyles from "../ExlyTable.styles";
import ExlyTabsWrapper from "common/Components/ExlyTabsWrapper";
import { useSessionParticipantsStore } from "ui/pages/ZoomAttendance/ZoomAttendanceOfListing/store/useSessionParticipantsStore";

const formatFilterObject = (
  tabFilterConfig,
  tabsDisabled,
  hideAllTab = false
) => {
  const _tabFilterConfig = tabFilterConfig.map((i) => {
    return {
      ...i,
      value: i.value || i.label,
      disabled: tabsDisabled,
    };
  });

  return hideAllTab
    ? _tabFilterConfig
    : [{ label: "All", value: "all" }, ..._tabFilterConfig];
};

const ExlyTabFilters = ({
  setFilters,
  filterValues,
  tabFilterConfig,
  setValue,
  value,
  tabsDisabled,
  wrapperClasses,
  hideAllTab, // hideAllTab flag is used when we don't want to show the all tabs in tab filters
  initialTabToShow,
}) => {
  const classes = useStyles();
  const [subTabValue, setSubTabValue] = useState();
  const [subTab, setSubTab] = useState(null);
  const _tabFilterConfig = formatFilterObject(
    tabFilterConfig,
    tabsDisabled,
    hideAllTab
  );

  useEffect(() => {
    if (filterValues) {
      useSessionParticipantsStore.getState().setFilterValues(filterValues);
    }
    //set Pre-selected on load.
    for (let i = 0; i < _tabFilterConfig.length; i++) {
      const filter = _tabFilterConfig[i];

      if (
        filter.source &&
        Object.keys(filterValues).indexOf(filter.source) !== -1 &&
        String(filterValues[filter.source]) === String(filter.filterValue)
      ) {
        //level one filter.
        return setValue(filter.value);
      } else if (filter.subTabs) {
        //level two filters
        return filter.subTabs.forEach((subFilter) => {
          if (
            Object.keys(filterValues).indexOf(subFilter.source) !== -1 &&
            filterValues[subFilter.source] === subFilter.value
          ) {
            setSubTab(filter.subTabs);
            setValue(filter.value);
            setSubTabValue(subFilter.value);
          }
        });
      }
    }

    setValue(initialTabToShow); // if neither filter present, reset to the default tab
  }, [filterValues]);

  const applyFilter = useCallback(
    ({ source, filterValue }) => {
      useSessionParticipantsStore
        .getState()
        .setFilterValues({ [source]: filterValue });
      setFilters({ [source]: filterValue });
    },
    [setFilters, subTabValue, value]
  );

  const handleChange = useCallback((event, newValue) => {
    setValue(newValue);
    useSessionParticipantsStore.getState().setActiveTab(newValue);
    const selectedFilter = _tabFilterConfig.find(
      (filter) => filter.value === newValue
    );

    if (selectedFilter?.value === "all") {
      //Remove Tab Filters.
      useSessionParticipantsStore.getState().setFilterValues({});
      setFilters({});
      setSubTabValue();
      setSubTab(null);
      return;
    }
    if (!selectedFilter?.subTabs) {
      //No Sub Filters
      applyFilter(selectedFilter);
      setSubTabValue();
      setSubTab(null);
      return;
    }
    //Sub Filters
    setFilters({});
    setSubTab(selectedFilter.subTabs);
  }, []);

  const handleSubTabChange = useCallback(
    (event, newValue) => {
      setSubTabValue(newValue);
      const selectedFilter = subTab?.find(
        (filter) => filter.value === newValue
      );
      applyFilter(selectedFilter);
    },
    [subTab]
  );

  return (
    <Box className={wrapperClasses ? wrapperClasses.tabsWrapper : ""}>
      <ExlyTabsWrapper>
        <Tabs
          key="level-one"
          value={value}
          tabVariant="filled_primary"
          onChange={handleChange}
          tabs={_tabFilterConfig}
        />
      </ExlyTabsWrapper>
      {!!subTab && (
        <Box className={classes.subTabWrapper}>
          <Tabs
            key="level-two"
            value={subTabValue}
            tabVariant="filled_secondary"
            onChange={handleSubTabChange}
            tabs={subTab}
          />
        </Box>
      )}
    </Box>
  );
};

export default ExlyTabFilters;
